// ============================================================================
// DESK
// ============================================================================

import CONFIG from '../config.js';

export class Desk {
    constructor(x, y, physics = null) {
        this.x = x;
        this.y = y;
        this.width = 80;
        this.height = 50;
        this.physics = physics;
        
        if (physics) {
            this.body = physics.createRectangle(x, y, this.width, this.height, {
                isStatic: true,
                frictionAir: 0,
                friction: 0,
                restitution: 0
            });
            physics.linkEntity(this, this.body);
        } else {
            this.body = null;
        }
    }
    
    update(dt) {
        if (this.body) {
            this.x = this.body.position.x;
            this.y = this.body.position.y;
        }
    }

    draw(ctx, camera) {
        ctx.save();

        const drawX = this.x;
        const drawY = this.y;

        // --- 3/4 PERSPECTIVE SETTINGS ---
        const depth = 8;
        const heightOffset = 25;

        const darkerColor = '#654321';
        const topColor = '#A0826D';
        const deskColor = '#8B4513';

        // 1. Draw SIDE/THICKNESS
        ctx.fillStyle = darkerColor;
        ctx.fillRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, this.height + heightOffset);

        // 2. Draw TOP SURFACE
        ctx.fillStyle = topColor;
        ctx.fillRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, depth);
        ctx.strokeStyle = '#000';
        ctx.strokeRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, depth);

        // 3. Draw FRONT FACE
        const frontY = drawY - this.height / 2 - heightOffset + depth;
        const frontHeight = this.height + heightOffset - depth;

        ctx.fillStyle = deskColor;
        ctx.fillRect(drawX - this.width / 2, frontY, this.width, frontHeight);
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 2;
        ctx.strokeRect(drawX - this.width / 2, frontY, this.width, frontHeight);

        // Laptop (on top surface, visible from front)
        const laptopWidth = 40;
        const laptopHeight = 25;
        const laptopY = drawY - this.height / 2 - heightOffset + 3;
        
        ctx.fillStyle = '#2C2C2C';
        ctx.fillRect(drawX - laptopWidth / 2, laptopY, laptopWidth, laptopHeight);
        ctx.strokeStyle = '#000';
        ctx.strokeRect(drawX - laptopWidth / 2, laptopY, laptopWidth, laptopHeight);

        // Screen
        ctx.fillStyle = '#1a1a1a';
        ctx.fillRect(drawX - laptopWidth / 2 + 2, laptopY + 2, laptopWidth - 4, laptopHeight - 8);
        
        // Screen glow
        ctx.fillStyle = 'rgba(100, 150, 255, 0.3)';
        ctx.fillRect(drawX - laptopWidth / 2 + 2, laptopY + 2, laptopWidth - 4, laptopHeight - 8);

        // Keyboard area
        ctx.fillStyle = '#404040';
        ctx.fillRect(drawX - laptopWidth / 2 + 2, laptopY + laptopHeight - 6, laptopWidth - 4, 3);

        ctx.restore();
    }
}
